import axios from 'axios';
import DEPLOYMENT_CONFIG from '../config/deployment';

const API_BASE_URL = DEPLOYMENT_CONFIG.getBackendUrl();

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('jwt_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export interface ProductResource {
    id: number;
    category: 'telecomunicacao' | 'energia' | 'seguranca';
    name: string;
    url: string;
    uploaded_at: string;
    uploaded_by: string;
    folder_id?: number | null;
}

export interface ResourceFolder {
    id: number;
    name: string;
    category: 'telecomunicacao' | 'energia' | 'seguranca';
    parent_folder_id?: number | null;
    created_by?: number;
}

export const productResourcesApi = {
    getResources: async (): Promise<Record<string, ProductResource[]>> => {
        const response = await api.get('/api/product-resources');
        return response.data;
    },

    getFolders: async (): Promise<Record<string, ResourceFolder[]>> => {
        const response = await api.get('/api/product-resources/folders');
        return response.data;
    },

    // Method to download/view (usually handled by browser via URL, but if we need a blob)
    downloadResource: async (id: number): Promise<Blob> => {
        const response = await api.get(`/api/product-resources/${id}/download`, {
            responseType: 'blob'
        });
        return response.data;
    }
};
